export type CurrencyCode =
    | "USD"
    | "CAD"
    | "EUR"
    | "GBP"
    | "AUD"
    | "JPY"
    | "KRW"
    | "NOK"
    | "THB"
    | "SEK";

export const currencyMap: Record<CurrencyCode, string> = {
    USD: "$",
    CAD: "C$",
    EUR: "€",
    GBP: "£",
    AUD: "A$",
    JPY: "¥",
    KRW: "₩",
    NOK: "kr",
    THB: "฿",
    SEK: "kr",
};

export function getCurrencySymbol(abbreviation: CurrencyCode): string {
    return currencyMap[abbreviation] || abbreviation;
}
